<template>
    <div class="project-classify">
        <div class="classify-content">
            <div class="project-classify-list">
                <div class="header-select">
                    <div style="font-size: 32px; color: #3C3C3C; margin: 60px 0 0 0;">项目库</div>
                    <div class="item" style="margin: 30px 0 24px 0;">
                        <span class="sort-item" :class="{current_first: currentFirstClass === 0}" @click="chooseFirstClass(0)">全部</span>
                        <span class="sort-item"
                              :class="{current_first: currentFirstClass === selectItem.rc_id}"
                              v-for="selectItem in projectFirstClassList"
                              :key="selectItem.rc_id"
                              @click="chooseFirstClass(selectItem.rc_id)">
                        {{selectItem.rc_name}}
                    </span>
                    </div>
                    <div class="item second-item">
                        <span class="sort-item" v-if="projectSecondClassList.length > 0" :class="{current_second: currentSecondClass === 0}" @click="chooseSecondClass(0)">全部</span>
                        <span class="sort-item"
                              :class="{current_second: currentSecondClass === selectItem.rc_id}"
                              v-for="selectItem in projectSecondClassList"
                              :key="selectItem.rc_id"
                              @click="chooseSecondClass(selectItem.rc_id)">
                        {{selectItem.rc_name}}
                    </span>
                        <span v-if="projectSecondClassList.length === 0" class="sort-item">暂无数据</span>
                    </div>
                </div>
                <div class="third-class-list">
                    <div v-if="projectThirdClassList.length === 0" class="no-data">
                        <span>暂无数据</span>
                    </div>
                    <div class="category-list" v-else>
                        <div class="third-class-item" v-for="item in projectThirdClassList" @click="viewProjectDetail(item)">
                            <div class="cover">
                                <img :src="item.file_path.src" style="width: 100%;" v-if="item.file_path.src">
                                <div class="no-image" v-else>
                                    <el-image>
                                        <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                            </div>
                            <div class="third-class-info">
                                <span class="class-name" :title="item.rc_name">{{item.rc_name}}</span>
                                <div class="class-time-difficulty">
                                    <span class="time">总时长：{{item.total_project_time}}分钟</span>
                                    <div class="difficulty" v-if="item.avg_project_difficulty === 1">
                                        <span class="text">难度：</span>
                                        <i class="iconfont">&#xe64c;</i>
                                    </div>
                                    <div class="difficulty" v-if="item.avg_project_difficulty === 2">
                                        <span class="text">难度：</span>
                                        <i class="iconfont" v-for="n in item.avg_project_difficulty">&#xe64c;</i>
                                    </div>
                                    <div class="difficulty" v-if="item.avg_project_difficulty === 3">
                                        <span class="text">难度：</span>
                                        <i class="iconfont" v-for="n in item.avg_project_difficulty">&#xe64c;</i>
                                    </div>
                                    <div class="difficulty" v-if="item.avg_project_difficulty === 4">
                                        <span class="text">难度：</span>
                                        <i class="iconfont" v-for="n in item.avg_project_difficulty">&#xe64c;</i>
                                    </div>
                                    <div class="difficulty" v-if="item.avg_project_difficulty === 5">
                                        <span class="text">难度：</span>
                                        <i class="iconfont" v-for="n in item.avg_project_difficulty">&#xe64c;</i>
                                    </div>
                                </div>
                                <div class="class-view-like">
                                    <div class="view">
                                        <i class="iconfont">&#xe749;</i>
                                        {{item.sum_project_pv}}
                                    </div>
                                    <div class="like">
                                        <i class="iconfont">&#xeca1;</i>
                                        {{item.sum_project_live}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-content">
                    <el-pagination class="pages-left"
                        :current-page="projectClassPages.currentPageNum"
                        :page-size="projectClassPages.eachPageNum"
                        :total="projectClassPages.total" background
                        layout="prev, pager, next"
                        @current-change="projectClassCurrentChange">
                    </el-pagination>
                </div>
            </div>
            <div class="project-guess-list">
                <div class="guess-header">
                    <div class="guess-text" v-show="is_switch">
                        <!-- <img src="../../assets/images/project_01.png" class="header-img"> -->
                        <span class="header-text">热门推荐</span>
                    </div>
                    <div class="guess-text" v-show="!is_switch">
                        <!-- <img src="../../assets/images/project_02.png" class="header-img"> -->
                        <span class="header-text">猜你喜欢</span>
                    </div>
                    <div class="switch" @click="switchItem">
                        <i class="iconfont">&#xe753;</i>
                        <span class="switch-text">切换</span>
                    </div>
                </div>
                <div class="guess-content">
                    <div class="guess-list">
                        <div v-show="is_switch">
                            <div class="guess-item" v-for="item in hotProject" @click="viewDetail(item)">
                                <!-- <img src="../../assets/images/project_03.png" v-if="item.rank === 1">
                                <img src="../../assets/images/project_04.png" v-else-if="item.rank === 2">
                                <img src="../../assets/images/project_05.png" v-else-if="item.rank === 3">
                                <span class="nums" v-else>{{item.rank}}</span> -->
                                <img src="../../assets/images/project-item.png">
                                <div style="flex: 1; height: 100%; display: flex; flex-direction: column; justify-content: space-between; font-size: 12px; color: #99A2AA;">
                                    <div class="guess-title">{{item.project_title}}</div>
                                    <div>浏览：{{item.project_pv}}</div>
                                    <div>时长：{{item.duration}}分钟</div>
                                </div>
                            </div>
                        </div>
                        <div :native="false" v-show="!is_switch">
                            <div class="guess-item" v-for="item in guessLikeProject" @click="viewDetail(item)">
                                <!-- <img src="../../assets/images/project_03.png" v-if="item.rank === 1">
                                <img src="../../assets/images/project_04.png" v-else-if="item.rank === 2">
                                <img src="../../assets/images/project_05.png" v-else-if="item.rank === 3">
                                <span class="num" v-else>{{item.rank}}</span> -->
                                <img src="../../assets/images/project-item.png">
                                <div style="flex: 1; height: 100%; display: flex; flex-direction: column; justify-content: space-between; font-size: 12px; color: #99A2AA;">
                                    <div class="guess-title">{{item.project_title}}</div>
                                    <div>收藏：{{item.project_livenum }}</div>
                                    <div>时长：{{item.duration}}分钟</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProjectClassify",
        data() {
            return {
                //分类
                projectFirstClassList: [],
                projectSecondClassList: [],
                projectThirdClassList: [],
                currentFirstClass: null,
                currentSecondClass: null,
                //分页
                projectClassPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                //切换猜你喜欢/热门推荐
                is_switch: true,
                hotProject: [],
                guessLikeProject: [],
                tempCategoryList: [],
            }
        },
        mounted() {
            this.getProjectFirstClassList();
        },
        methods: {
            //获取项目库一级分类
            getProjectFirstClassList() {
                this.$shttp.axiosGet(this.$api.admin_projectClassList, (res) => {
                    console.log(res)
                    if (res.code === 200) {
                        this.projectFirstClassList = res.data.data;
                        if (res.data.data.length > 0) {
                            this.currentFirstClass = 0;
                            this.currentSecondClass = 0;
                            this.projectFirstClassList.forEach((item) => {
                                item.children.forEach((secondItem) => {
                                    this.projectSecondClassList.push(secondItem);
                                });
                            });

                            this.projectSecondClassList.forEach((item) => {
                                item.children.forEach((thirdItem) => {
                                    // this.projectThirdClassList.push(thirdItem);
                                    this.tempCategoryList.push(thirdItem)
                                });
                            });
                            this.projectThirdClassList = this.tempCategoryList.slice(0, this.projectClassPages.eachPageNum)
                            this.projectClassPages.total = this.tempCategoryList.length
                        }
                        this.hotProject = res.data.hotProject;
                        this.guessLikeProject = res.data.guessLikeProject;
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //获取项目库二级分类
            getProjectSecondClassList(id) {
                this.projectFirstClassList.forEach((item) => {
                    if (item.rc_id === id) {
                        this.projectSecondClassList = item.children;
                    }
                })
            },
            //获取项目库三级分类
            getProjectThirdClassList(id) {
                if (this.currentSecondClass > 0) {
                    this.projectFirstClassList.forEach((item) => {
                        item.children.forEach((thirdItem) => {
                            if (thirdItem.rc_id === id) {
                                this.projectThirdClassList = thirdItem.children;
                            }
                        })
                    })
                } else {
                    this.projectSecondClassList.forEach((item) => {
                        item.children.forEach((thirdItem) => {
                            this.projectThirdClassList.push(thirdItem);
                        });
                    });
                }
            },
            //选择一级分类
            chooseFirstClass(id) {
                this.currentFirstClass = id;
                this.projectSecondClassList = [];
                this.projectThirdClassList = [];
                if (id > 0) {
                    this.currentSecondClass = 0;
                    this.getProjectSecondClassList(id);
                    this.getProjectThirdClassList(id);
                } else {
                    this.currentSecondClass = 0;
                    this.projectFirstClassList.forEach((item) => {
                        item.children.forEach((secondItem) => {
                            this.projectSecondClassList.push(secondItem);
                        });
                    });
                    this.projectSecondClassList.forEach((item) => {
                        item.children.forEach((thirdItem) => {
                            this.projectThirdClassList.push(thirdItem);
                        });
                    });
                }
            },
            //选择二级分类
            chooseSecondClass(id) {
                this.currentSecondClass = id;
                this.projectThirdClassList = [];
                if (id > 0) {
                    this.getProjectThirdClassList(id);
                } else {
                    this.projectSecondClassList.forEach((item) => {
                        item.children.forEach((thirdItem) => {
                            this.projectThirdClassList.push(thirdItem);
                        });
                    });
                }
            },
            //点击三级分类
            viewProjectDetail(item) {
                this.$router.push({
                    path: '/qualityCourse/Project',
                    query: {
                        id: item.rc_id,
                        title: item.rc_name
                    }
                })
            },
            //点击三级分类
            viewDetail(item) {
                this.$router.push({
                    path: '/qualityCourse/project/detail',
                    query: {
                        p_id: item.id
                    },
                })
            },
            //分页
            projectClassCurrentChange(val) {
                this.projectClassPages.currentPageNum = val;
                const start = (val - 1) * this.projectClassPages.eachPageNum
                const end = this.projectClassPages.eachPageNum * val
                this.projectClassPages.currentPageNum = val;
                this.projectThirdClassList = this.tempCategoryList.slice(start, end)
                // this.getSchoolList();
            },
            //切换猜你喜欢/热门推荐
            switchItem() {
                this.is_switch = !this.is_switch;
            }
        }
    }
</script>

<style scoped lang="scss">
    .project-classify {
        & * {
          box-sizing: border-box;
        }
        display: flex;
        flex-direction: column;
        background-color: #fff;
        align-items: center;
        .classify-content {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            height: 100%;
            width: 1600px;
        }
        .project-classify-list {
            display: flex;
            flex: 1;
            flex-direction: column;
            height: 100%;
            .header-select {
                width: 100%;
                height: auto;
                background-color: #fff;
                .item {
                    display: flex;
                    flex-wrap: wrap;
                    color: #666666;
                    font-size: 16px;
                    .sort-item {
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        margin: 0 16px 10px 0;
                        padding: 0 7px;
                        border: 1px solid #DBDEE0;
                        border-radius: 4px;
                        &:hover {
                            cursor: pointer;
                        }
                    }
                    .current_first {
                        background: #006EFF;
                        border-radius: 4px;
                        color: #fff;
                        border-color: #006EFF;
                    }
                }
                .second-item {
                    font-size: 14px;
                    .current_second {
                        background: #006EFF;
                        border-radius: 4px;
                        color: #fff;
                        border-color: #006EFF;
                    }
                }
            }
            .third-class-list {
                display: flex;
                flex: 1;
                padding: 20px 0 60px 0;
                box-sizing: border-box;
                ::v-deep .el-scrollbar__wrap {
                    overflow-x: hidden;
                    .el-scrollbar__view {
                        display: flex;
                        flex-wrap: wrap;
                    }
                }
                .category-list {
                    width: 100%;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    grid-gap: 32px 24px;
                }
                .page-content {
                    display: flex;
                    width: 100%;
                    justify-content: center;
                    align-items: center;
                }
                .third-class-item {
                    display: flex;
                    width: 100%;
                    height: 160px;
                    background: #F2F6FA;
                    border-radius: 8px;
                    padding: 32px 16px;
                    &:hover {
                        cursor: pointer;
                    }
                    .cover {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        width: 120px;
                        height: 100%;
                        img {
                            /*max-width: 100%;*/
                            /*max-height: 100%;*/
                        }
                        .no-image {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 100px;
                            color: #EEEEEE;
                        }
                    }
                    .third-class-info {
                        display: flex;
                        flex: 1;
                        flex-direction: column;
                        justify-content: space-between;
                        padding-left: 8px;
                        .class-name {
                            font-size: 16px;
                            color: #333333;
                            font-weight: 550;
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .class-time-difficulty {
                            display: flex;
                            color: #999999;
                            font-size: 14px;
                            .time {
                                margin-right: 8px;
                            }
                            .difficulty {
                                i {
                                    color: #FFD83E;
                                    margin-left: -6px;
                                }
                            }
                        }
                        .class-view-like {
                            display: flex;
                            color: #7D7D7D;
                            .view, .like {
                                display: flex;
                                align-items: center;
                                i {
                                    margin-right: 5px;
                                }
                            }
                            .view {
                                margin-right: 30px;
                            }
                        }
                    }
                }
            }
        }
        .project-guess-list {
            height: 100%;
            box-sizing: border-box;
            & * {
              box-sizing: border-box;
            }
            display: flex;
            flex-direction: column;
            width: 300px;
            min-width: 300px;
            padding: 18px 20px 0;
            box-sizing: border-box;
            margin: 60px 0 60px 30px;
            .guess-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 30px;
                padding: 0 20px 17px 20px;
                border-bottom: 1px solid #DDDDDD;
                .guess-text {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    img.header-img {
                        width: 23px;
                        height: 19px;
                        margin-right: 16px;
                    }
                    span.header-text {
                        font-size: 18px;
                        color: #333;
                        font-weight: 550;
                    }
                }
                .switch {
                    display: flex;
                    align-items: center;
                    color: #999;
                    cursor: pointer;
                    i {
                        margin-right: 3px;
                        font-size: 18px;
                    }
                }
            }
            .guess-content {
                flex: 1;
                height: 1%;
                .guess-list {
                    height: 100%;
                    ::v-deep .el-scrollbar {
                        height: 100%;
                    }
                    ::v-deep .el-scrollbar__wrap {
                        overflow-x: hidden;
                    }
                    .guess-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 73px;
                        margin: 20px;
                        img {
                            width: 120px;
                            height: 100%;
                            margin-right: 10px;
                        }
                        .guess-title {
                            color: #666666;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            word-wrap:break-word;
                            cursor: pointer;
                        }
                        .num {
                            color: #666666;
                            font-size: 14px;
                        }
                        .rank {
                            display: block;
                            width: 29px;
                            font-size: 16px;
                            color: #999;
                            font-weight: bold;
                            text-align: center;
                        }
                    }
                }
            }
        }
        .pages-left {
            text-align: center;
        }
    }
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
    .nums {
        display: block;
        width: 23px;
        text-align: center;
    }
</style>